module.exports = __webpack_public_path__ + "static/media/newmsg.c76a6688.mp3";